// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_ji-0";